<template>
  <div v-if="!hide">
      <div class="update">
        <div class="form-update">
            <el-tabs type="border-card" v-model="activeTab">
              <el-tab-pane label="Memo" name = "memo">
                <el-form class="formMemo" ref="formMemo" label-position="top" :model="formMemo" :rules="rulesMemo">
                  <el-form-item label="Memo" prop="memo">
                    <el-input type="textarea" :autosize="{ minRows: 5}" v-model="formMemo.memo"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top:10px;">
                    <el-button :loading="loadingMemo" class="submit-button" type="primary" @click="update('formMemo')" :disabled="memoDisable">Submit</el-button>
                    <vue-twitter-counter class="counter" underlay="#67C23A" :current-length="formMemo.memo.length" :dangerAt="1004" ></vue-twitter-counter>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="Review" name = "review">
                <el-form class="formReview" label-position="top" ref="formReview" :model="formReview" :rules="rulesReview">
                  <el-form-item label="Review" prop="rate">
                    <el-rate
                      v-model="formReview.rate"
                      :texts="['oops', 'disappointed', 'normal', 'good', 'great']"
                      show-text>
                    </el-rate>
                  </el-form-item>
                  <el-form-item label="your experience">
                    <el-input :autosize="{ minRows: 5}" type="textarea" v-model="formReview.review"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top:10px;">
                    <el-button :loading="loadingReview" class="submit-button" type="primary" @click="update('formReview')">Submit</el-button>
                    <vue-twitter-counter class="counter" underlay="#67C23A" :current-length="JSON.stringify(formReview).length" :dangerAt="1004" ></vue-twitter-counter>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <!-- commented because it will be move to another components -->
              <!-- <el-tab-pane label="Repair" name = "repair">
                <el-form class="formRepair" label-position="top" ref="formRepair" :model="formRepair" :rules="rulesRepair">
                  <el-form-item label="Categories" prop="category">
                    <el-select v-model="formRepair.category" placeholder="please choose a category">
                      <el-option label="Watch case" value="c"></el-option>
                      <el-option label="Glass" value="g"></el-option>
                      <el-option label="strap" value="s"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Details" prop="detail">
                    <el-input type="textarea" v-model="formRepair.detail"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top:10px;">
                    <el-button type="primary" @click="update('formRepair')">Submit</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="Lost &amp; Found" name="lost-found">
                <el-form class="formLost" ref="formLost" label-position="top" :model="formLost" :rules="rulesLost">
                  <el-form-item label="What happend?" prop="type">
                    <el-select v-model="formLost.type" placeholder="What happend?">
                      <el-option label="Lost" value="l"></el-option>
                      <el-option label="Found" value="f"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Information">
                    <el-input type="textarea" v-model="formLost.info"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-top:10px;">
                    <el-button type="primary" @click="update('formLost')">Submit</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane> -->
            </el-tabs>
        </div>
      </div>
    </div>
</template>
<script>
import vueTwitterCounter from 'vue-twitter-counter';
import luxtagApi from '../API/index';
import nem from '../../static/js/index';

// const format = nem.utils.format;

function sendUpdate(vm, common, updateMessage) {
  const that = vm;
  nem.com.requests.account.data(vm.$store.getters.getEndpoints.web[vm.count],
    vm.$route.params.address).then((resp) => {
      // get asset PP
      const network = nem.model.network.data.mainnet.id;
      const assetPP = resp.account.publicKey;
      const assetAddress = nem.utils.format.pubToAddress(assetPP, network);

      const transferTransaction = {
        amount: 0,
        recipient: assetAddress,
        // recipientPublicKey: "",
        isMultisig: true,
        multisigAccount: {
          publicKey: assetPP,
        },
        message: JSON.stringify(updateMessage),
        messageType: 1,
      };

      const transactionEntity = nem.model.transactions.prepare('transferTransaction')(common, transferTransaction, network);
      // tx fee shim for NEM-sdk message fee estimation
      // transactionEntity.fee = 150000;
      // transactionEntity.otherTrans.fee /= 20;


      nem.model.transactions.send(
        common,
        transactionEntity,
        vm.$store.getters.getEndpoints.web[vm.count]).then((res) => {
          // If code >= 2, it's an error
          if (res.code >= 2) {
            vm.$message({
              type: 'error',
              message: res.message,
              showClose: true,
            });
          } else {
            // stop the laoding
            that.loadingMemo = false;
            that.loadingReview = false;
            vm.$message({
              type: 'success',
              message: 'Message sent succfully',
            });
            that.formMemo = {
              memo: '',
            };
            that.formReview = {
              rate: null,
              review: '',
            };
          }
        }, (err) => {
        });
    }).catch((e) => {
      vm.$message({
        type: 'error',
        message: 'Account request canceled',
        showClose: true,
      });
    });
}

export default {
  props: ['count', 'width', 'hide'],
  data() {
    const checkRate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please choose the rate of the product'));
      }
      return callback();
    };
    return {
      QRVoucher: '',
      updateMessage: {},
      activeTab: 'memo',
      inputypePrng: 'password',
      iconPrng: 'eye-slash',
      icolorPrng: '#13CE66',
      loadingMemo: false,
      loadingReview: false,
      formMemo: {
        memo: '',
      },
      formReview: {
        rate: null,
        review: '',
      },
      formRepair: {
        category: '',
        detail: '',
      },
      formLost: {
        type: '',
        info: '',
      },
      rulesMemo: {
        memo: [
          { required: true, message: 'Please input something to be sent!', trigger: 'blur' },
        ],
      },
      rulesReview: {
        rate: [
          { required: true, validator: checkRate, message: 'Please choose the rate of current product' },
        ],
      },
      rulesRepair: {
        category: [
          { required: true, message: 'Please choose a category', trigger: 'change' },
        ],
        detail: [
          { required: true, message: 'Please Enter more details', trigger: 'blur' },
        ],
      },
      rulesLost: {
        type: [
          { required: true, message: 'Please choose an option', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    showpassPrng: function () {
      if (this.inputypePrng === 'password') {
        this.inputypePrng = 'text';
        this.iconPrng = 'eye';
        this.icolorPrng = '#FF4949';
      } else if (this.inputypePrng === 'text') {
        this.inputypePrng = 'password';
        this.iconPrng = 'eye-slash';
        this.icolorPrng = '#13CE66';
      }
    },
    update(formName) {
      const that = this;
      const getters = this.$store.getters;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if the form is validated
          if (formName === 'formMemo') {
            // message form input goes here
            this.updateMessage = {
              T: 0, // form index
              U: {
                M: this.formMemo.memo, // Memo
              },
            };
            that.loadingMemo = true;
          } else if (formName === 'formReview') {
            // message form input goes here
            this.updateMessage = {
              T: 1, // form index
              U: {
                S: this.formReview.rate, // Score
                M: this.formReview.review, // Message
              },
            };
            that.loadingReview = true;
          } else if (formName === 'formRepair') {
            this.updateMessage = {
              T: 2, // form index
              U: {
                C: this.formRepair.category, // Categorie
                M: this.formRepair.detail, // Message
              },
            };
          } else if (formName === 'formLost') {
            this.updateMessage = {
              T: 3, // form index
              U: {
                T: this.formLost.type, // Type
                M: this.formLost.info, // Message
              },
            };
          }
          // GET current user
          // get passphrase
          // generate private key
          luxtagApi.user.me()
          .then((response) => {
            // JSON responses are automatically parsed.
            const common = {
              address: getters.getAccounts[getters.getAuth.index].accounts[0].address,
              privateKey: nem.crypto.helpers.derivePassSha(response.data.passphrase, 6000).priv,
            };
            sendUpdate(that, common, that.updateMessage);
          })
          .catch((error) => {
            that.$message.error({
              showClose: true,
              message: `${error}`,
            });
          });
          return false;
        }
        that.$message.error({
          showClose: true,
          message: 'Invalid Form!',
        });
        return false;
      });
    },
  },
  computed: {
    memoDisable() {
      if (this.formMemo.memo.length > 1004) {
        return true;
      }
      return false;
    },
  },
  components: {
    vueTwitterCounter,
  },
  created() {
    const that = this;
    this.addr = that.$store.getters.getAccounts[that.$store.getters.getAuth.index]
                .accounts[0].address;
    this.name = that.$store.getters.getAccounts[that.$store.getters.getAuth.index].name;
    /* eslint-disable quote-props */
    // QR structure for voucher
    const QRVoucherObj = {
      'v': that.$store.getters.getAccounts[that.$store.getters.getAuth.index].accounts[0].network ===
        nem.model.network.data.mainnet.id ? 1 : 2,
      'type': 1,
      'data': {
        'addr': that.$store.getters.getAccounts[that.$store.getters.getAuth.index].accounts[0].address,
        'name': that.$store.getters.getAccounts[that.$store.getters.getAuth.index].name,
      },
    };
    that.QRVoucher = JSON.stringify(QRVoucherObj);
  },
};
</script>

<style lang="scss">
.update {
  background-color: #ffffff;
  .form-update {
    max-width: 100%;
    margin: auto;
    .el-tabs {
      widows: 100%;
      .el-tabs__content {
        height: auto !important;
        .el-tab-pane {
          .el-form {
            width: 100%;
            text-align: left;
            .el-form-item {
              margin-bottom: 0px;
              .el-form-item__content {
                padding-top: 0px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
              }
            }
          }
        }
      }
    }
  }
}

.submit-button {
  float: right;
}

.counter {
  float: right;
  margin: 10px;
}
</style>




// WEBPACK FOOTER //
// UpdateProduct.vue?9778ccea